export const environment = {
  production: true,
  url: '',
  STORAGE_REQ_KEY: "storedreq",
  secretKey: 'MIICXAIBAAKBgQDfmlc2EgrdhvakQApmLCDOgP0nNERInBheMh7J/r5aU8PUAIpGXET/8'
}
